import SliderNext from "@assets/restaurant/slider-next.svg";
import SliderPrev from "@assets/restaurant/slider-prev.svg";
import { twMerge } from "tailwind-merge";

export const ScrollButton = ({
  isDisabled,
  onClick,
  isPrevious,
}: {
  isDisabled?: boolean;
  onClick: () => void;
  isPrevious?: boolean;
}) => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        "flex justify-center w-[28px] h-[28px] p-1.5 bg-brand-primary rounded-full disabled:opacity-30",
        isDisabled && "opacity-[60%]",
      )}
    >
      <img
        alt="toggle-button-chevie"
        height={24}
        width={24}
        className={twMerge("inline")}
        src={isPrevious ? SliderPrev : SliderNext}
      />
    </button>
  );
};
